import VueRouter from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from '../store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

window.roleWiseRoutes = {
  agent: [],
  administrator: [],
};

// generateRoleWiseRoute - updates window object with agent/admin route
const generateRoleWiseRoute = route => {
  route.forEach(element => {
    if (element.children) {
      generateRoleWiseRoute(element.children);
    }
    if (element.roles) {
      element.roles.forEach(roleEl => {
        window.roleWiseRoutes[roleEl].push(element.name);
      });
    }
  });
};
// Create a object of routes
// accessible by each role.
// returns an object with roles as keys and routeArr as values
generateRoleWiseRoute(routes);

export const router = new VueRouter({ mode: 'history', routes });

const SMART_AI_EMAIL_CAMPAIGN_ROUTES = [
  'smart_ai_email_campaign',
  'smart_ai_email_campaign_contacts',
];

export const validateAuthenticateRoutePermission = async (to, next, store) => {
  const { getters, dispatch } = store;

  const { isLoggedIn, getCurrentUser: user } = getters;

  if (!isLoggedIn) {
    window.location = '/app/login';
    return '/app/login';
    }

  if (!to.name) {
    return next({
      path: frontendURL(`accounts/${user.account_id}/reports`),
      replace: true,
    });
  }

  const nextRoute = validateLoggedInRoutes(
    to,
    getters.getCurrentUser,
    window.roleWiseRoutes
  );
  if (nextRoute) {
    return next(frontendURL(nextRoute));
  }

  // Block Smart AI Email Campaign routes when feature is disabled for the account.
  if (
    SMART_AI_EMAIL_CAMPAIGN_ROUTES.includes(to.name) &&
    to.params.accountId
  ) {
    const accountId = Number(to.params.accountId);
    let account = getters['accounts/getAccount'](accountId);
    let hasFeatures = account && typeof account.features === 'object' && Object.keys(account.features || {}).length > 0;

    // If account or features not loaded yet (e.g. direct URL access or refresh), load account first
    if (!hasFeatures) {
      try {
        await dispatch('accounts/get');
        account = getters['accounts/getAccount'](accountId);
        hasFeatures = account && typeof account.features === 'object' && Object.keys(account.features || {}).length > 0;
      } catch (_) {
        // If fetch fails, allow navigation (page may show error)
      }
    }

    // API returns only enabled_features, so disabled features are missing from the hash.
    // Redirect when the feature is not explicitly enabled (missing or false).
    if (hasFeatures && account.features.smart_ai_email_campaign !== true) {
      return next({
        path: frontendURL(
          `accounts/${accountId}/campaigns/whatsapp_campaigns`
        ),
        replace: true,
      });
    }
  }

  return next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach(async (to, from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    await userAuthentication;
    await validateAuthenticateRoutePermission(to, next, store);
  });
};

export default router;
